require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./gnie-lectrique-et-lectronique-2-1-3-3.json") })
        }
      }, "path---gnie-lectrique-et-lectronique-2-1-3-3");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---gnie-lectrique-et-lectronique-2-1-3-3!./.cache/json/gnie-lectrique-et-lectronique-2-1-3-3.json
// module id = 449
// module chunks = 231608221292675